

// import React, { useState, useEffect, useMemo } from "react";
// import axios from "axios";
// import "../styles/SavingReport.css";

// const SavingReport = () => {
//   const [activeTab, setActiveTab] = useState("All");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [accountType, setAccountType] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [accountsData, setAccountsData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const rowsPerPage = 5;

//   const fetchAccounts = async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const superAdminId = localStorage.getItem("adminuserId") || 14;

//       const response = await axios.get("https://narrowitsolution.in/api/get-all-saving-account", {
//         params: { superAdminId },
//       });

//       if (Array.isArray(response.data.accounts)) {
//         setAccountsData(response.data.accounts);
//       } else {
//         setAccountsData([]);
//       }
//     } catch (err) {
//       console.error("Error fetching saving accounts:", err);
//       setError("Failed to load saving accounts.");
//       setAccountsData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAccounts();
//   }, []);

//   const filteredData = useMemo(() => {
//     let data = [...accountsData];

//     if (activeTab !== "All") data = data.filter((item) => item.status === activeTab);

//     if (searchQuery.trim()) {
//       data = data.filter((item) =>
//         Object.values(item)
//           .join(" ")
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase())
//       );
//     }

//     if (accountType) data = data.filter((item) => item.accountType === accountType);

//     if (fromDate)
//       data = data.filter((item) => new Date(item.openedDate) >= new Date(fromDate));
//     if (toDate)
//       data = data.filter((item) => new Date(item.openedDate) <= new Date(toDate));

//     return data;
//   }, [accountsData, activeTab, searchQuery, accountType, fromDate, toDate]);

//   const totalPages = Math.ceil(filteredData.length / rowsPerPage);
//   const paginatedData =
//     activeTab === "All"
//       ? filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
//       : filteredData;



// const approveAccount = async (id) => {
//   try {
//     const adminId = localStorage.getItem("adminuserId") || 1;

//     await axios.put(`https://narrowitsolution.in/api/saving-account/approve/${id}`, {
//       approvedBy: adminId
//     });

//     alert("Account Approved Successfully!");
//     fetchAccounts();  // refresh list
//   } catch (error) {
//     console.error("Approve Error:", error);
//     alert("Failed to approve account");
//   }
// };

// const rejectAccount = async (id) => {
//   const adminId = localStorage.getItem("adminuserId") || 1;
//   const reason = prompt("Enter Reject Reason:");

//   if (!reason) return alert("Reject reason is required!");

//   try {
//     await axios.put(`https://narrowitsolution.in/api/saving-account/reject/${id}`, {
//       rejectedBy: adminId,
//       rejectReason: reason,
//     });

//     alert("Account Rejected Successfully!");
//     fetchAccounts(); // refresh list
//   } catch (error) {
//     console.error("Reject Error:", error);
//     alert("Failed to reject account");
//   }
// };





//   return (
//     <div className="SR-container">
//       <h2 className="SR-title">Saving Account Report</h2>

//       {/* Filters */}
//       <div className="SR-filter-box">
//         <input
//           type="text"
//           placeholder="Search name, account no..."
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />

//         <select value={accountType} onChange={(e) => setAccountType(e.target.value)}>
//           <option value="">All Account Types</option>
//           <option value="Saving">Saving</option>
//           <option value="Current">Current</option>
//         </select>

//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

//         <button className="SR-apply" onClick={() => setCurrentPage(1)}>Apply</button>
//         <button
//           className="SR-reset"
//           onClick={() => {
//             setSearchQuery("");
//             setAccountType("");
//             setFromDate("");
//             setToDate("");
//             setActiveTab("All");
//           }}
//         >
//           Reset
//         </button>
//       </div>

//       {/* Loading / Error */}
//       {loading && <p className="SR-loading">Loading accounts...</p>}
//       {error && <p className="SR-error">{error}</p>}

//       {/* Table */}
//       <div className="SR-table-wrapper">
//         <table className="SR-table">
//           <thead>
//             <tr>
//               <th>SN</th>
//               <th>Account No</th>
//               <th>Customer Name</th>
//               <th>Account Type</th>
//               <th>Status</th>
//               <th>Opened Date</th>
//               <th>Opening Balance</th>
//               <th>Current Balance</th>
//               <th>Refer ID</th>
//               <th>Nominee ID</th>
//               <th>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {paginatedData.length > 0 ? (
//               paginatedData.map((item, index) => (
//                 <tr key={item.id}>
//                   <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//                   <td>{item.accountNumber || "--"}</td>
//                   <td>{item.customerName || "--"}</td>
//                   <td>{item.accountType || "--"}</td>
//                   <td>{item.status || "--"}</td>
//                   <td>{item.openedDate?.split("T")[0] || "--"}</td>
//                   <td>₹{item.openingBalance || "0"}</td>
//                   <td>₹{item.currentBalance || "0"}</td>
//                   <td>{item.referId || "--"}</td>
//                   <td>{item.nomineeId || "--"}</td>
//                <div style={{ display: "flex", gap: "6px" }}>
//   {item.status === "Pending" && (
//     <>
//       <button
//         className="SR-approve-btn"
//         style={{ background: "green", color: "white", padding: "4px 8px", borderRadius: "4px", border: "none" }}
//         onClick={() => approveAccount(item.id)}
//       >
//         Accept
//       </button>

//       <button
//         className="SR-reject-btn"
//         style={{ background: "red", color: "white", padding: "4px 8px", borderRadius: "4px", border: "none" }}
//         onClick={() => rejectAccount(item.id)}
//       >
//         Reject
//       </button>
//     </>
//   )}

//   {item.status !== "Pending" && (
//     <span style={{ fontWeight: "bold", color: "#555" }}>
//       {item.status}
//     </span>
//   )}
// </div>

//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="11" style={{ textAlign: "center" }}>No Data Found</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination (Centered) */}
//       {activeTab === "All" && filteredData.length > rowsPerPage && (
//         <div className="SR-pagination">
//           <button
//             onClick={() => setCurrentPage(currentPage - 1)}
//             disabled={currentPage === 1}
//           >
//             ⬅ Prev
//           </button>

//           <span>
//             Page {currentPage} of {totalPages}
//           </span>

//           <button
//             onClick={() => setCurrentPage(currentPage + 1)}
//             disabled={currentPage === totalPages}
//           >
//             Next ➡
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SavingReport;





import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "../styles/SavingReport.css";

const SavingReport = () => {
  const [activeTab, setActiveTab] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [accountType, setAccountType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [accountsData, setAccountsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const rowsPerPage = 5;

  // Fetch Saving Accounts
  const fetchAccounts = async () => {
    try {
      setLoading(true);
      setError("");

      const superAdminId = localStorage.getItem("adminuserId") || 14;

      const response = await axios.get(
        "https://narrowitsolution.in/api/get-all-saving-account",
        { params: { superAdminId } }
      );

      if (Array.isArray(response.data.accounts)) {
        setAccountsData(response.data.accounts);
      } else {
        setAccountsData([]);
      }
    } catch (err) {
      console.error("Error fetching saving accounts:", err);
      setError("Failed to load saving accounts.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  // Filtering Logic
  const filteredData = useMemo(() => {
    let data = [...accountsData];

    if (activeTab !== "All") data = data.filter((item) => item.status === activeTab);
    if (searchQuery.trim()) {
      data = data.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
    }
    if (accountType) data = data.filter((item) => item.accountType === accountType);
    if (fromDate) data = data.filter((item) => new Date(item.openedDate) >= new Date(fromDate));
    if (toDate) data = data.filter((item) => new Date(item.openedDate) <= new Date(toDate));

    return data;
  }, [accountsData, activeTab, searchQuery, accountType, fromDate, toDate]);

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const paginatedData =
    activeTab === "All"
      ? filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
      : filteredData;

  // Approve Account API
  const approveAccount = async (id) => {
    try {
      const adminId = localStorage.getItem("adminuserId") || 1;

      await axios.put(
        `https://narrowitsolution.in/api/saapproveSavingAccount/${id}`,
        { approvedBy: adminId }
      );

      alert("Account Approved Successfully!");
      fetchAccounts();
    } catch (error) {
      console.error("Approve Error:", error);
      alert("Failed to approve account");
    }
  };

  // Reject Account API
  const rejectAccount = async (id) => {
    const adminId = localStorage.getItem("adminuserId") || 1;
    const reason = prompt("Enter Reject Reason:");

    if (!reason) return alert("Reject reason is required!");

    try {
      await axios.put(
        `https://narrowitsolution.in/api/saving-account/reject/${id}`,
        { rejectedBy: adminId, rejectReason: reason }
      );

      alert("Account Rejected Successfully!");
      fetchAccounts();
    } catch (error) {
      console.error("Reject Error:", error);
      alert("Failed to reject account");
    }
  };

  return (
    <div className="SR-container">
      <h2 className="SR-title">Saving Account Report</h2>

      {/* Filters */}
      <div className="SR-filter-box">
        <input
          type="text"
          placeholder="Search name, account no..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />

        <select value={accountType} onChange={(e) => setAccountType(e.target.value)}>
          <option value="">All Account Types</option>
          <option value="Saving">Saving</option>
          <option value="Current">Current</option>
        </select>

        <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
        <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

        <button className="SR-apply" onClick={() => setCurrentPage(1)}>Apply</button>
        <button
          className="SR-reset"
          onClick={() => {
            setSearchQuery("");
            setAccountType("");
            setFromDate("");
            setToDate("");
            setActiveTab("All");
          }}
        >
          Reset
        </button>
      </div>

      {loading && <p className="SR-loading">Loading accounts...</p>}
      {error && <p className="SR-error">{error}</p>}

      {/* Table */}
      <div className="SR-table-wrapper">
        <table className="SR-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Account No</th>
              <th>Customer Name</th>
              <th>Account Type</th>
              <th>Status</th>
              <th>Opened Date</th>
              <th>Opening Balance</th>
              <th>Current Balance</th>
              <th>Refer ID</th>
              <th>Nominee ID</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((item, index) => (
                <tr key={item.id}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{item.accountNumber || "--"}</td>
                  <td>{item.customerName || "--"}</td>
                  <td>{item.accountType || "--"}</td>
                  <td>{item.status || "--"}</td>
                  <td>{item.openedDate?.split("T")[0] || "--"}</td>
                  <td>₹{item.openingBalance || "0"}</td>
                  <td>₹{item.currentBalance || "0"}</td>
                  <td>{item.referId || "--"}</td>
                  <td>{item.nomineeId || "--"}</td>

                  {/* FIXED: Action Column */}
                  <td>
                    <div className="SR-action-btns">
                      {item.status === "Pending" ? (
                        <>
                          <button
                            className="SR-approve-btn"
                            onClick={() => approveAccount(item.id)}
                          >
                            Accept
                          </button>

                          <button
                            className="SR-reject-btn"
                            onClick={() => rejectAccount(item.id)}
                          >
                            Reject
                          </button>
                        </>
                      ) : (
                        <span className="SR-status-label">{item.status}</span>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" style={{ textAlign: "center" }}>
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {activeTab === "All" && filteredData.length > rowsPerPage && (
        <div className="SR-pagination">
          <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
            ⬅ Prev
          </button>
          <span>Page {currentPage} of {totalPages}</span>
          <button
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next ➡
          </button>
        </div>
      )}
    </div>
  );
};

export default SavingReport;
